import { IEvent } from "../types/Event";

export default function mergeSimilarEvents(emptyEvents: IEvent[], mergeEvents: IEvent[]){
    return emptyEvents.map(emptyEvent => {
        const similarEvent = mergeEvents.find(event => event.start === emptyEvent.start && event.end === emptyEvent.end && event.startDay === emptyEvent.startDay&& event.endDay === emptyEvent.endDay && event.startWeek === emptyEvent.startWeek&& event.endWeek === emptyEvent.endWeek);
        return similarEvent ?? emptyEvent;
    })
}